export default "__VITE_ASSET__Cn97RoYj__"